export var cibFeathub = ["32 32", "<path d='M11.641 0.016h8.719v9.156h-8.719zM11.641 22.828h8.719v9.156h-8.719zM0.016 11.641h31.969v8.719h-31.969z'/>"];
